import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  importProvidersFrom,
  inject,
} from '@angular/core';
import Aura from '@primeng/themes/aura';
import { appRoutes } from './app.routes';
import { provideRouter, withPreloading } from '@angular/router';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import {
  DialogService,
  DynamicDialogModule,
  providePrimeNG,
} from '@moofyvip-ui-shared/exports/primeng';
import { esTranslation } from '@moofyvip-ui-shared/translantion/primeng';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { environment } from '@moofyvip-ui-shared/environments/environments';
import { FontAwesomeicons } from '@moofyvip-ui-shared/assets/icons/fontawesome';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { landingCriticalPreloadStore } from './landing-critical-preload.store';
import { OrderedRoutePreloadingStrategy } from './ordered-route-preloading-strategy';
import { firebaseAuthStore } from '@moofyvip-ui-shared/stores/fireauthStore/auth.store';

export const appConfig: ApplicationConfig = {
  providers: [
    DialogService,
    provideRouter(appRoutes, withPreloading(OrderedRoutePreloadingStrategy)),
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    importProvidersFrom(DynamicDialogModule),
    provideZonelessChangeDetection(),
    provideHttpClient(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
      translation: { ...esTranslation },
    }),

    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth(getApp())),
    provideFirestore(() => {
      const app = getApp();
      if (environment.firestoreDatabaseId === '(default)')
        return getFirestore(app);
      return getFirestore(app, environment.firestoreDatabaseId);
    }),
    provideFunctions(() => getFunctions(getApp(), 'us-central1')),
    provideAppInitializer(() => {
      inject(FaIconLibrary).addIcons(...FontAwesomeicons);
    }),
    provideAppInitializer(() => {
      inject(landingCriticalPreloadStore);
    }),
    provideAppInitializer(() =>
      inject(firebaseAuthStore).restoreApprovedSession(),
    ),
  ],
};
